import { Alert, Box, Button, Card, CardContent, CardMedia, CircularProgress, Container, FormControl, Grid, IconButton, InputLabel, MenuItem, Paper, Select, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import React, { useState } from 'react'
import { createJob, deleteJob, fetchJobs, updateJob } from './hooks/hooks';
import { Add, ArrowBack, CloudUpload, Delete, Edit, Info } from '@mui/icons-material';
import { useFormik } from 'formik';
import * as Yup from 'yup';

// Validation Schema using Yup
const validationSchema = Yup.object({
  title: Yup.string()
    .required('Title is required')
    .max(200, 'Title must be at most 200 characters'),
  description: Yup.string()
    .required('Description is required')
    .min(50, 'Description must be at least 50 characters'),
  contact_info: Yup.string()
    .required('Contact info is required')
    .max(200, 'Contact info must be at most 200 characters'),
  image: Yup.mixed()
    .required('Image is required')
    .test('fileType', 'Only image files are allowed', (value) => {
      if (value) {
        return ['image/jpeg', 'image/png', 'image/gif'].includes(value.type);
      }
      return true;
    }),
});
  // Validation Schema using Yup
const upValidationSchema = Yup.object({
  title: Yup.string()
    .required('Title is required')
    .max(200, 'Title must be at most 200 characters'),
  description: Yup.string()
    .required('Description is required')
    .min(50, 'Description must be at least 50 characters'),
  contact_info: Yup.string()
    .required('Contact info is required')
    .max(200, 'Contact info must be at most 200 characters'),
   
  });
function ForMore() {
  const queryClient = useQueryClient();
  const { data:jobs, isLoading, error, refetch } = useQuery({
         queryKey: ['jobs'],
         queryFn: fetchJobs,
     });
     
         const [selectedItem, setSelectedItem] = useState(null);
         const [open, setOpen] = useState({ create: false, update: false, detail: false });
         // const [formData, setFormData] = useState({ title: "", content: "", image: null });
         // const [formDataEdit, setFormDataEdit] = useState({ title: "", content: "", image: null  });
         const [toast, setToast] = useState({ open: false, message: "", severity: "" }); const [searchQuery, setSearchQuery] = useState("");
         const [sortBy, setSortBy] = useState("date"); // Default sorting by date
         const [page, setPage] = useState(0);
         const [rowsPerPage, setRowsPerPage] = useState(5);
     
          // Ensure news is an array before filtering
          const filteredNews = Array.isArray(jobs) ? jobs.filter(item =>
             item.title?.toLowerCase().includes(searchQuery.toLowerCase())
         ) : [];
     
     
         // Sort news dynamically
         const sortedNews = [...filteredNews].sort((a, b) => {
             if (sortBy === "title") {
                 return a.title.localeCompare(b.title);
             } else {
                 return new Date(b.published_at) - new Date(a.published_at); // Latest first
             }
         });
     
         // Handle Pagination
         const handleChangePage = (_, newPage) => setPage(newPage);
         const handleChangeRowsPerPage = (event) => {
             setRowsPerPage(parseInt(event.target.value, 10));
             setPage(0);
         };
     
         // Update News Mutation
         const updateMutation = useMutation({
             mutationFn: updateJob,
             onSuccess: () => {
                 queryClient.invalidateQueries(["jobUpdate"]);
                 // setFormDataEdit({ title: "", content: "", image: null });
                 setOpen({ create: false, update: false, detail:false });
                 setToast({ open: true, message: "Your changes have been saved.", severity: "success" });
             },
             onError: (error) => {
               setToast({ open: true, message: "Unable to save changes. Please check your inputs.", severity: "error" });
             }
         });
     
         // Delete News Mutation
         const deleteMutation = useMutation({
             mutationFn: deleteJob,
             onSuccess: () => {
                 queryClient.invalidateQueries(["jobDelete"]);
                 setToast({ open: true, message: "Service deleted successfully!", severity: "success" });
             },
             onError: (error) => {
                 setToast({ open: true, message: "Failed to delete service. Please try again.", severity: "error" });
             }
         });

     

    const mutation = useMutation({
      mutationFn: createJob, // Ensure `createNews` is a function
      onSuccess: (response) => {
        queryClient.invalidateQueries({ queryKey: ["jobPost"] }); // Uncomment if needed
      //   setFormData({ title: "", content: "", image: null });
        setOpen({ create: false, update: false, detail:false });
        setToast({ open: true, message: "Your expertise is now live and visible to clients.", severity: "success" });
         refetch()
      },
      onError: (error) => {
        setToast({ open: true, message: "Something went wrong. Your service was not published.", severity: "error" });
      }
    });

    const handleDelete = (id) => {
      deleteMutation.mutate(id);
  };

   const formik = useFormik({
    initialValues: {
      title:'',
      description:'',
      contact_info:'',
      image: null,
    },
      validationSchema: validationSchema,
      onSubmit: (values) => {
        mutation.mutate(values);
      },
    });

    const upformik = useFormik({
      initialValues: {
        title:'',
        description:'',
        contact_info:'',
        image: null,
      },
        validationSchema: upValidationSchema,
        onSubmit: (values) => {
          if (selectedItem.id) {
          updateMutation.mutate({ id: selectedItem.id, data: values });
        }
        },
      });

    
     // Open drawer and set form data when updating
  const handleOpenUpdateDrawer = (item) => {
    setSelectedItem(item);
    // Update formik values dynamically
  upformik.setValues({
    title: item.title || '',
    description: item.description || '',
    contact_info: item.contact_info || '',
    image: null, // Keep image null initially
  });
    setOpen({ create: false, update: true });
  };
  const handleOpenDetailsDrawer = (item) => {
    setSelectedItem(item);
    setOpen({ create: false, update: false, detail:true });
  };

  // Function to toggle create drawer
  const toggleDrawer = (type, state) => () => {
    setOpen({ create: type === "create" ? state : false, update: type === "update" ? state : false });
    // if (type === "create") {
    //   setFormDataEdit({ title: "", content: "", image: null }); // Reset form for create
    // }
  };

  if (isLoading) {
    return (
        <Container sx={{ textAlign: "center", marginTop: 5 }}>
            <Typography>Loading...</Typography>
        </Container>
    );
}

if (error) {
    return (
        <Container sx={{ textAlign: "center", marginTop: 5 }}>
            <Typography variant="h6" color="error">
                Error fetching jobs. Please try again later.
            </Typography>
        </Container>
    );
}

  return (
    <Container>
      {jobs?.length === 0 ? (
        <Container maxWidth="md">
        <Box
          sx={{
            mt: "4px",
            p: "4px",
            // borderRadius: 2,
            boxShadow: 0,
            backgroundColor: 'background.paper',
          }}
        >
          <Typography variant="h4" sx={{ fontWeight: 700, color: "#001f3f", fontSize:12, textTransform:"uppercase" }}>
            Advertise Your Expertise
          </Typography>
          <Typography variant="body1" sx={{mb:2, color: "text.secondary", fontSize: 10, textTransform:"capitalize" }}>
            Fill out the form below to showcase your expertise and attract new clients.
          </Typography>
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={3}>
              {/* Title Field */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  label="Title"
                  variant="outlined"
                  name="title"
                  value={formik.values.title}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.title && Boolean(formik.errors.title)}
                  helperText={formik.touched.title && formik.errors.title}
                  InputLabelProps={{
                    sx: {
                      color: "#555", // Default label color
                      fontSize: 10,
                      transition: "color 0.3s ease",
                      "&:hover": {
                          color: "#333"
                      }, // Label color on hover
                      "&.Mui-focused": { 
                          color: "#001f3f",
                          textTransform:"uppercase",
                          fontWeight:500
                      }, // Label color on focus
                    },
                  }}
                  inputProps={{
                    sx: {
                      fontSize: 10, // Field content size
                      color: "#333", // Field content color
                      "&::placeholder": {
                        color: "#aaa", // Placeholder color
                        fontSize: 10,
                      },
                    },
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: "2px",
                      "&.Mui-focused fieldset": { 
                          borderColor: "#001f3f",
                          borderRadius:"2px"
                      }, // Focus border
                    },
                    '& .MuiFormHelperText-root': {
                      fontSize: 9, // Smaller font size for validation errors
                      color: 'error.main', // Red color for errors
                      textTransform:"capitalize"
                    },
                  
                  }}
                />
              </Grid>
  
              {/* Content Field */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  multiline
                  rows={6}
                  label="Description"
                  name="description"
                  value={formik.values.description}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.description && Boolean(formik.errors.description)}
                  helperText={formik.touched.description && formik.errors.description}
                  InputLabelProps={{
                    sx: {
                      color: "#555", // Default label color
                      fontSize: 10,
                      transition: "color 0.3s ease",
                      "&:hover": {
                          color: "#333"
                      }, // Label color on hover
                      "&.Mui-focused": { 
                          color: "#001f3f",
                          textTransform:"uppercase",
                          fontWeight:500
                      }, // Label color on focus
                    },
                  }}
                  inputProps={{
                    sx: {
                      fontSize: 10, // Field content size
                      color: "#333", // Field content color
                      "&::placeholder": {
                        color: "#aaa", // Placeholder color
                        fontSize: 10,
                      },
                    },
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: "2px",
                      "&.Mui-focused fieldset": { 
                          borderColor: "#001f3f",
                          borderRadius:"2px"
                      }, // Focus border
                    },
                    '& .MuiFormHelperText-root': {
                      fontSize: 9, // Smaller font size for validation errors
                      color: 'error.main', // Red color for errors
                      textTransform:"capitalize"
                    },
                  }}
                />
              </Grid>
              {/* Content Field */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  label="Contact Info"
                  name="contact_info"
                  value={formik.values.contact_info}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.contact_info && Boolean(formik.errors.contact_info)}
                  helperText={formik.touched.contact_info && formik.errors.contact_info}
                  InputLabelProps={{
                    sx: {
                      color: "#555", // Default label color
                      fontSize: 10,
                      transition: "color 0.3s ease",
                      "&:hover": {
                          color: "#333"
                      }, // Label color on hover
                      "&.Mui-focused": { 
                          color: "#001f3f",
                          textTransform:"uppercase",
                          fontWeight:500
                      }, // Label color on focus
                    },
                  }}
                  inputProps={{
                    sx: {
                      fontSize: 10, // Field content size
                      color: "#333", // Field content color
                      "&::placeholder": {
                        color: "#aaa", // Placeholder color
                        fontSize: 10,
                      },
                    },
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: "2px",
                      "&.Mui-focused fieldset": { 
                          borderColor: "#001f3f",
                          borderRadius:"2px"
                      }, // Focus border
                    },
                    '& .MuiFormHelperText-root': {
                      fontSize: 9, // Smaller font size for validation errors
                      color: 'error.main', // Red color for errors
                      textTransform:"capitalize"
                    },
                  }}
                />
              </Grid>
  
              {/* Image Upload Field */}
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  component="label"
                  sx={{
                    color:"black",
                    fontSize:10,
                    fontWeight:500,
                    borderRadius: '2px',
                    textTransform: 'none',
                    boxShadow:"none",
                    py: 1,
                    px: 3,
                    border:"1px solid #ccc",
                    // background:"none"
                    backgroundColor:"#fff",                     
                    "&:hover": {
                        boxShadow: "none",
                    },
                  }}
                >
                    <Box sx={{
                        alignItems:"center",
                        justifyContent:"center",
                        display:"flex",
                        flexDirection:"column"
                    }}>
                        <CloudUpload color="gray" />
                        <Typography sx={{
                            fontSize:10,
                            fontWeight:500,
                            textTransform:"capitalize"
                        }}>Click to upload</Typography>
                        <Typography sx={{
                            fontSize:10,
                            fontWeight:400,
                            color:"#bcbcbc"
                        }}>JPEG, PNG or GIF</Typography>
                        <input
                            type="file"
                            hidden
                            name="image"
                            onChange={(event) => {
                            formik.setFieldValue('image', event.currentTarget.files[0]);
                            }}
                            onBlur={formik.handleBlur}
                            accept="image/*"
                        />
                    </Box>
                 
                </Button>
                {formik.touched.image && formik.errors.image && (
                  <Typography variant="body2" color="error" sx={{ mt: 1, fontSize:10, textTransform:"capitalize" }}>
                    {formik.errors.image}
                  </Typography>
                )}
                {formik.values.image && (
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="body2" sx={{ mb: 1, fontSize:10, }}>
                       SELECTED FILE: {formik.values.image.name}
                    </Typography>
                    <img
                      src={URL.createObjectURL(formik.values.image)}
                      alt="Preview"
                      style={{
                        maxWidth: '100%',
                        height: 'auto',
                        maxHeight:400,
                        borderRadius: '2px',
                        boxShadow: 0,
                      }}
                    />
                  </Box>
                )}
              </Grid>
  
              {/* Submit Button */}
              <Grid item xs={12}>
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  size="large"
                  sx={{
                    borderRadius: "2px",
                    textTransform: 'none',
                    py: 1.5,
                    fontSize: 10,
                    boxShadow:0,
                    backgroundColor:"#001f3f",                  
                    "&:hover": {
                        boxShadow: "none",
                    },
                  }}
                >
                  Publish Service
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Container>
      ):(   
        open.create?(
          <Container maxWidth="md">
            
          <IconButton
              onClick={toggleDrawer("create", false)}
          >
              <ArrowBack/>
          </IconButton>
        <Box
          sx={{
            mt: "4px",
            p: "4px",
            // borderRadius: 2,
            boxShadow: 0,
            backgroundColor: 'background.paper',
          }}
        >
          
          <Typography variant="h4" sx={{ fontWeight: 700, color: "#001f3f", fontSize:12, textTransform:"uppercase" }}>
            Advertise Your Expertise
          </Typography>
          <Typography variant="body1" sx={{mb:2, color: "text.secondary", fontSize: 10, textTransform:"capitalize" }}>
            Fill out the form below to showcase your expertise and attract new clients.
          </Typography>
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={3}>
              {/* Title Field */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  label="Title"
                  variant="outlined"
                  name="title"
                  value={formik.values.title}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.title && Boolean(formik.errors.title)}
                  helperText={formik.touched.title && formik.errors.title}
                  InputLabelProps={{
                    sx: {
                      color: "#555", // Default label color
                      fontSize: 10,
                      transition: "color 0.3s ease",
                      "&:hover": {
                          color: "#333"
                      }, // Label color on hover
                      "&.Mui-focused": { 
                          color: "#001f3f",
                          textTransform:"uppercase",
                          fontWeight:500
                      }, // Label color on focus
                    },
                  }}
                  inputProps={{
                    sx: {
                      fontSize: 10, // Field content size
                      color: "#333", // Field content color
                      "&::placeholder": {
                        color: "#aaa", // Placeholder color
                        fontSize: 10,
                      },
                    },
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: "2px",
                      "&.Mui-focused fieldset": { 
                          borderColor: "#001f3f",
                          borderRadius:"2px"
                      }, // Focus border
                    },
                    '& .MuiFormHelperText-root': {
                      fontSize: 9, // Smaller font size for validation errors
                      color: 'error.main', // Red color for errors
                      textTransform:"capitalize"
                    },
                  
                  }}
                />
              </Grid>
  
              {/* Content Field */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  multiline
                  rows={6}
                  label="Description"
                  name="description"
                  value={formik.values.description}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.description && Boolean(formik.errors.description)}
                  helperText={formik.touched.description && formik.errors.description}
                  InputLabelProps={{
                    sx: {
                      color: "#555", // Default label color
                      fontSize: 10,
                      transition: "color 0.3s ease",
                      "&:hover": {
                          color: "#333"
                      }, // Label color on hover
                      "&.Mui-focused": { 
                          color: "#001f3f",
                          textTransform:"uppercase",
                          fontWeight:500
                      }, // Label color on focus
                    },
                  }}
                  inputProps={{
                    sx: {
                      fontSize: 10, // Field content size
                      color: "#333", // Field content color
                      "&::placeholder": {
                        color: "#aaa", // Placeholder color
                        fontSize: 10,
                      },
                    },
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: "2px",
                      "&.Mui-focused fieldset": { 
                          borderColor: "#001f3f",
                          borderRadius:"2px"
                      }, // Focus border
                    },
                    '& .MuiFormHelperText-root': {
                      fontSize: 9, // Smaller font size for validation errors
                      color: 'error.main', // Red color for errors
                      textTransform:"capitalize"
                    },
                  }}
                />
              </Grid>
              {/* Content Field */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  label="Contact Info"
                  name="contact_info"
                  value={formik.values.contact_info}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.contact_info && Boolean(formik.errors.contact_info)}
                  helperText={formik.touched.contact_info && formik.errors.contact_info}
                  InputLabelProps={{
                    sx: {
                      color: "#555", // Default label color
                      fontSize: 10,
                      transition: "color 0.3s ease",
                      "&:hover": {
                          color: "#333"
                      }, // Label color on hover
                      "&.Mui-focused": { 
                          color: "#001f3f",
                          textTransform:"uppercase",
                          fontWeight:500
                      }, // Label color on focus
                    },
                  }}
                  inputProps={{
                    sx: {
                      fontSize: 10, // Field content size
                      color: "#333", // Field content color
                      "&::placeholder": {
                        color: "#aaa", // Placeholder color
                        fontSize: 10,
                      },
                    },
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: "2px",
                      "&.Mui-focused fieldset": { 
                          borderColor: "#001f3f",
                          borderRadius:"2px"
                      }, // Focus border
                    },
                    '& .MuiFormHelperText-root': {
                      fontSize: 9, // Smaller font size for validation errors
                      color: 'error.main', // Red color for errors
                      textTransform:"capitalize"
                    },
                  }}
                />
              </Grid>
  
              {/* Image Upload Field */}
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  component="label"
                  sx={{
                    color:"black",
                    fontSize:10,
                    fontWeight:500,
                    borderRadius: '2px',
                    textTransform: 'none',
                    boxShadow:"none",
                    py: 1,
                    px: 3,
                    border:"1px solid #ccc",
                    // background:"none"
                    backgroundColor:"#fff",                     
                    "&:hover": {
                        boxShadow: "none",
                    },
                  }}
                >
                    <Box sx={{
                        alignItems:"center",
                        justifyContent:"center",
                        display:"flex",
                        flexDirection:"column"
                    }}>
                        <CloudUpload color="gray" />
                        <Typography sx={{
                            fontSize:10,
                            fontWeight:500,
                            textTransform:"capitalize"
                        }}>Click to upload</Typography>
                        <Typography sx={{
                            fontSize:10,
                            fontWeight:400,
                            color:"#bcbcbc"
                        }}>JPEG, PNG or GIF</Typography>
                        <input
                            type="file"
                            hidden
                            name="image"
                            onChange={(event) => {
                            formik.setFieldValue('image', event.currentTarget.files[0]);
                            }}
                            onBlur={formik.handleBlur}
                            accept="image/*"
                        />
                    </Box>
                 
                </Button>
                {formik.touched.image && formik.errors.image && (
                  <Typography variant="body2" color="error" sx={{ mt: 1, fontSize:10, textTransform:"capitalize" }}>
                    {formik.errors.image}
                  </Typography>
                )}
                {formik.values.image && (
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="body2" sx={{ mb: 1, fontSize:10, }}>
                       SELECTED FILE: {formik.values.image.name}
                    </Typography>
                    <img
                      src={URL.createObjectURL(formik.values.image)}
                      alt="Preview"
                      style={{
                        maxWidth: '100%',
                        height: 'auto',
                        maxHeight:400,
                        borderRadius: '2px',
                        boxShadow: 0,
                      }}
                    />
                  </Box>
                )}
              </Grid>
  
              {/* Submit Button */}
              <Grid item xs={12}>
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  size="large"
                  sx={{
                    borderRadius: "2px",
                    textTransform: 'none',
                    py: 1.5,
                    fontSize: 10,
                    boxShadow:0,
                    backgroundColor:"#001f3f",                  
                    "&:hover": {
                        boxShadow: "none",
                    },
                  }}
                >
                  Publish Service
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Container>

        ):open.update?(
          <Container maxWidth="md">
            
          <IconButton
              onClick={toggleDrawer("update", false)}
          >
              <ArrowBack/>
          </IconButton>
        <Box
          sx={{
            mt: "4px",
            p: "4px",
            // borderRadius: 2,
            boxShadow: 0,
            backgroundColor: 'background.paper',
          }}
        >
          <Typography variant="h4" sx={{ fontWeight: 700, color: "#001f3f", fontSize:12, textTransform:"uppercase" }}>
            Advertise Your Expertise
          </Typography>
          <Typography variant="body1" sx={{mb:2, color: "text.secondary", fontSize: 10, textTransform:"capitalize" }}>
            Fill out the form below to showcase your expertise and attract new clients.
          </Typography>
          <form onSubmit={upformik.handleSubmit}>
            <Grid container spacing={3}>
              {/* Title Field */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  label="Title"
                  variant="outlined"
                  name="title"
                  value={upformik.values.title}
                  onChange={upformik.handleChange}
                  onBlur={upformik.handleBlur}
                  error={upformik.touched.title && Boolean(upformik.errors.title)}
                  helperText={upformik.touched.title && upformik.errors.title}
                  InputLabelProps={{
                    sx: {
                      color: "#555", // Default label color
                      fontSize: 10,
                      transition: "color 0.3s ease",
                      "&:hover": {
                          color: "#333"
                      }, // Label color on hover
                      "&.Mui-focused": { 
                          color: "#001f3f",
                          textTransform:"uppercase",
                          fontWeight:500
                      }, // Label color on focus
                    },
                  }}
                  inputProps={{
                    sx: {
                      fontSize: 10, // Field content size
                      color: "#333", // Field content color
                      "&::placeholder": {
                        color: "#aaa", // Placeholder color
                        fontSize: 10,
                      },
                    },
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: "2px",
                      "&.Mui-focused fieldset": { 
                          borderColor: "#001f3f",
                          borderRadius:"2px"
                      }, // Focus border
                    },
                    '& .MuiFormHelperText-root': {
                      fontSize: 9, // Smaller font size for validation errors
                      color: 'error.main', // Red color for errors
                      textTransform:"capitalize"
                    },
                  
                  }}
                />
              </Grid>
  
              {/* Content Field */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  multiline
                  rows={6}
                  label="Description"
                  name="description"
                  value={upformik.values.description}
                  onChange={upformik.handleChange}
                  onBlur={upformik.handleBlur}
                  error={upformik.touched.description && Boolean(upformik.errors.description)}
                  helperText={upformik.touched.description && upformik.errors.description}
                  InputLabelProps={{
                    sx: {
                      color: "#555", // Default label color
                      fontSize: 10,
                      transition: "color 0.3s ease",
                      "&:hover": {
                          color: "#333"
                      }, // Label color on hover
                      "&.Mui-focused": { 
                          color: "#001f3f",
                          textTransform:"uppercase",
                          fontWeight:500
                      }, // Label color on focus
                    },
                  }}
                  inputProps={{
                    sx: {
                      fontSize: 10, // Field content size
                      color: "#333", // Field content color
                      "&::placeholder": {
                        color: "#aaa", // Placeholder color
                        fontSize: 10,
                      },
                    },
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: "2px",
                      "&.Mui-focused fieldset": { 
                          borderColor: "#001f3f",
                          borderRadius:"2px"
                      }, // Focus border
                    },
                    '& .MuiFormHelperText-root': {
                      fontSize: 9, // Smaller font size for validation errors
                      color: 'error.main', // Red color for errors
                      textTransform:"capitalize"
                    },
                  }}
                />
              </Grid>
              {/* Content Field */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  label="Contact Info"
                  name="contact_info"
                  value={upformik.values.contact_info}
                  onChange={upformik.handleChange}
                  onBlur={upformik.handleBlur}
                  error={upformik.touched.contact_info && Boolean(upformik.errors.contact_info)}
                  helperText={upformik.touched.contact_info && upformik.errors.contact_info}
                  InputLabelProps={{
                    sx: {
                      color: "#555", // Default label color
                      fontSize: 10,
                      transition: "color 0.3s ease",
                      "&:hover": {
                          color: "#333"
                      }, // Label color on hover
                      "&.Mui-focused": { 
                          color: "#001f3f",
                          textTransform:"uppercase",
                          fontWeight:500
                      }, // Label color on focus
                    },
                  }}
                  inputProps={{
                    sx: {
                      fontSize: 10, // Field content size
                      color: "#333", // Field content color
                      "&::placeholder": {
                        color: "#aaa", // Placeholder color
                        fontSize: 10,
                      },
                    },
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: "2px",
                      "&.Mui-focused fieldset": { 
                          borderColor: "#001f3f",
                          borderRadius:"2px"
                      }, // Focus border
                    },
                    '& .MuiFormHelperText-root': {
                      fontSize: 9, // Smaller font size for validation errors
                      color: 'error.main', // Red color for errors
                      textTransform:"capitalize"
                    },
                  }}
                />
              </Grid>
  
              {/* Image Upload Field */}
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  component="label"
                  sx={{
                    color:"black",
                    fontSize:10,
                    fontWeight:500,
                    borderRadius: '2px',
                    textTransform: 'none',
                    boxShadow:"none",
                    py: 1,
                    px: 3,
                    border:"1px solid #ccc",
                    // background:"none"
                    backgroundColor:"#fff",                     
                    "&:hover": {
                        boxShadow: "none",
                    },
                  }}
                >
                    <Box sx={{
                        alignItems:"center",
                        justifyContent:"center",
                        display:"flex",
                        flexDirection:"column"
                    }}>
                        <CloudUpload color="gray" />
                        <Typography sx={{
                            fontSize:10,
                            fontWeight:500,
                            textTransform:"capitalize"
                        }}>Click to upload</Typography>
                        <Typography sx={{
                            fontSize:10,
                            fontWeight:400,
                            color:"#bcbcbc"
                        }}>JPEG, PNG or GIF</Typography>
                        <input
                            type="file"
                            hidden
                            name="image"
                            onChange={(event) => {
                            upformik.setFieldValue('image', event.currentTarget.files[0]);
                            }}
                            onBlur={upformik.handleBlur}
                            accept="image/*"
                        />
                    </Box>
                 
                </Button>
                {/* {formik.touched.image && formik.errors.image && (
                  <Typography variant="body2" color="error" sx={{ mt: 1, fontSize:10, textTransform:"capitalize" }}>
                    {formik.errors.image}
                  </Typography>
                )} */}
                {formik.values.image && (
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="body2" sx={{ mb: 1, fontSize:10, }}>
                       SELECTED FILE: {formik.values.image.name}
                    </Typography>
                    <img
                      src={URL.createObjectURL(formik.values.image)}
                      alt="Preview"
                      style={{
                        maxWidth: '100%',
                        height: 'auto',
                        maxHeight:400,
                        borderRadius: '2px',
                        boxShadow: 0,
                      }}
                    />
                  </Box>
                )}
              </Grid>
  
              {/* Submit Button */}
              <Grid item xs={12}>
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  size="large"
                  sx={{
                    borderRadius: "2px",
                    textTransform: 'none',
                    py: 1.5,
                    fontSize: 10,
                    boxShadow:0,
                    backgroundColor:"#001f3f",                  
                    "&:hover": {
                        boxShadow: "none",
                    },
                  }}
                >
                  Apply Changes
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Container>
        ):open.detail?(
          <Box
          sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              // justifyContent: "center",
              width: "100%",
              // padding: 3,
          }}
          >
          <IconButton
              onClick={toggleDrawer("detail", false)}
          >
              <ArrowBack/>
          </IconButton>

          <Container maxWidth="md" sx={{ mt: { xs: 2, sm: 5 } }}>
              <Card
              elevation={0}
              sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" }, // Column on small screens, Row on larger screens
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: 0,
                  borderRadius: "2px",
                  overflow: "hidden",
              }}
              >
              {/* IMAGE SECTION */}
              {selectedItem?.image && (
                  <CardMedia
                  component="img"
                  image={`http://192.168.1.199:8000${selectedItem.image}`}
                  alt={selectedItem?.title}
                  sx={{
                      width: { xs: "100%", sm: "50%" }, // Full width on small screens, Half width on large screens
                      height: "auto",
                      objectFit: "cover",
                  }}
                  />
              )}

              {/* CONTENT SECTION */}
              <CardContent
                  sx={{
                  width: { xs: "100%", sm: "50%" }, // Full width on small screens, Half width on large screens
                  p: { xs: 2, sm: 3 },
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  }}
              >
                  <Typography
                  variant="h6"
                  sx={{
                      fontWeight: 700,
                      color: "#001f3f",
                      fontSize: { xs: 10, sm: 12 },
                  }}
                  gutterBottom
                  >
                  {selectedItem?.title}
                  </Typography>

                  <Typography
                  variant="body2"
                  sx={{
                      mb: 2,
                      color: "text.secondary",
                      fontSize: { xs: 9, sm: 10 },
                      textTransform: "capitalize",
                      whiteSpace: "pre-line",
                  }}
                  >
                  {selectedItem?.description}
                  </Typography>
                  <Typography
                  variant="caption"
                  display="block"
                  sx={{
                      mt: 2,
                      color: "#bcbcbc",
                      fontSize: { xs: 8, sm: 10 },
                      fontWeight: 500,
                  }}
                  >
                  Contact Info: {selectedItem?.contact_info}
                  </Typography>

                  <Typography
                  variant="caption"
                  display="block"
                  sx={{
                      mt: 2,
                      color: "#bcbcbc",
                      fontSize: { xs: 8, sm: 10 },
                      fontWeight: 500,
                  }}
                  >
                  Published on: {new Date(selectedItem?.published_at).toLocaleDateString()}
                  </Typography>
              </CardContent>
              </Card>
          </Container>
          </Box>
        ):(
          <Box>
            <Typography variant="h2" component="h2" 
            sx={{ 
                fontSize:12,
                fontWeight:700,
                textTransform:"uppercase"
            }}
            >
                Manage Your Services
            </Typography>
            <Typography variant="body1" component="h2" 
            sx={{ 
                marginBottom: 2,
                color: "text.secondary",
                textTransform:"capitalize",
                fontSize:10
            }}>
                Add, update, or remove your service listings to attract more clients.
            </Typography>
            <Button
            startIcon={<Add/>}
            variant="contained"
            // color="primary"
            elevation={0}
            disableElevation={true}
            onClick={toggleDrawer("create", true)}
            sx={{ 
                mb: 1,
                color:"#001f3f",
                borderRadius:"1px",
                fontSize:10,
                fontWeight:500,
                textTransform:"capitalize",
                background:"none",
                textDecoration:"underline"
             }}
             >
               
               Click here to Add New Job
            </Button>
            <Typography variant="h4" component="h4" 
            sx={{ 
                mt:2,mb:1,
                fontSize:10,
                textTransform:"uppercase",
                fontWeight:600
                
                 }}>
                Your Service Listings
            </Typography>
            
             {/* Responsive Search and Sort Controls */}
             <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={8}>
                    <TextField
                        label="Search by Title"
                        variant="outlined"
                        size="small"
                        fullWidth
                        InputLabelProps={{
                          sx: {
                            color: "#555", // Default label color
                            fontSize: 10,
                            transition: "color 0.3s ease",
                            "&:hover": {
                                color: "#333"
                            }, // Label color on hover
                            "&.Mui-focused": { 
                                color: "#001f3f",
                                textTransform:"uppercase",
                                fontWeight:500
                            }, // Label color on focus
                          },
                        }}
                        inputProps={{
                          sx: {
                            fontSize: 10, // Field content size
                            color: "#333", // Field content color
                            "&::placeholder": {
                              color: "#aaa", // Placeholder color
                              fontSize: 10,
                            },
                          },
                        }}
                        sx={{
                          backgroundColor: "#e8e8e8",
                          borderRadius: "1px",
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": { 
                                borderColor: "#ccc",  
                                borderRadius:"2px"
                             }, // Default border
                            "&:hover fieldset": { 
                                borderColor: "#0000",
                                borderRadius:"2px"
                             }, // Hover border
                            "&.Mui-focused fieldset": { 
                                borderColor: "#001f3f",
                                borderRadius:"2px"
                            }, // Focus border
                          },
                        }}
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormControl
                    size="small"
                    fullWidth
                    
                    sx={{
                      backgroundColor: "#e8e8e8",
                      borderRadius: "1px",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { 
                            borderColor: "#ccc",  
                            borderRadius:"2px"
                         }, // Default border
                        "&:hover fieldset": { 
                            borderColor: "#0000",
                            borderRadius:"2px"
                         }, // Hover border
                        "&.Mui-focused fieldset": { 
                            borderColor: "#001f3f",
                            borderRadius:"2px"
                        }, // Focus border
                      },
                    }}
                    >
                        <InputLabel 
                        sx={{
                            color: "#555", // Default color
                            fontSize: 10, // Default font size
                            transition: "color 0.3s ease, font-size 0.3s ease",
                            "&:hover": {
                              color: "#333", // Color on hover
                            },
                            "&.Mui-focused": { 
                              color: "#001f3f", // Color on focus
                              textTransform: "uppercase",
                              fontWeight: 500,
                              fontSize: 10, // Font size on focus
                            },
                          }}>Sort By</InputLabel>
                        <Select
                        value={sortBy}
                        onChange={(e) => setSortBy(e.target.value)}
                        label="Sort By"
                        InputLabelProps={{
                        sx: {
                            color: "#555", // Default label color
                            fontSize: 10,
                            transition: "color 0.3s ease",
                            "&:hover": {
                                color: "#333"
                            }, // Label color on hover
                            "&.Mui-focused": { 
                                color: "#001f3f",
                                textTransform:"uppercase",
                                fontWeight:500
                            }, // Label color on focus
                        },
                        }}
                        MenuProps={{
                            PaperProps: {
                              sx: {
                                boxShadow: "none", // Removes box shadow
                                elevation: 0, // Ensures no elevation
                                border: "1px solid #ccc", // Optional: Adds a subtle border for separation
                                backgroundColor: "#fff", // Ensures a clean white background
                                mt: 1.5, 
                                borderRadius:"1px"
                              },
                            },
                          }}
                        inputProps={{
                        sx: {
                            fontSize: 10, // Field content size
                            color: "#333", // Field content color
                            "&::placeholder": {
                            color: "#aaa", // Placeholder color
                            fontSize: 10,
                            },
                        },
                        }}
                        >
                            <MenuItem value="date" 
                                sx={{
                                    fontSize:10,
                                    textTransform:"capitalize",
                                    fontWeight:500,
                                    "&.Mui-selected": { 
                                        backgroundColor: "#001f3f !important", // Active item color (Red)
                                        color: "white",
                                    },
                                    "&:hover": {
                                        backgroundColor: "#CCDDEE", // Lighter red on hover
                                    },
                                }}
                            >
                                Published Date
                            </MenuItem>
                            <MenuItem value="title"

                                sx={{
                                    fontSize:10,
                                    textTransform:"capitalize",
                                    fontWeight:500,
                                    "&.Mui-selected": { 
                                        backgroundColor: "#001f3f !important", // Active item color (Red)
                                        color: "white",

                                    },
                                    "&:hover": {
                                        backgroundColor: "#CCDDEE", // Lighter red on hover
                                    },
                                }}
                            >
                                Title
                            </MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
            <TableContainer component={Paper} elevation={0}>
            <Table>
                <TableHead>
                    <TableRow>
                        {/* <TableCell sx={{
                            fontSize:10,
                            fontWeight:600,
                            textTransform:"uppercase"
                        }}>Image</TableCell> */}
                        <TableCell sx={{
                            fontSize:8,
                            fontWeight:600,
                            textTransform:"uppercase"
                        }}>Title</TableCell>
                        <TableCell sx={{
                            fontSize:8,
                            fontWeight:600,
                            textTransform:"uppercase"
                        }}>description</TableCell>
                        <TableCell sx={{
                            fontSize:8,
                            fontWeight:600,
                            textTransform:"uppercase"
                        }}>contact info</TableCell>
                        
                        <TableCell sx={{
                            fontSize:8,
                            fontWeight:600,
                            textTransform:"uppercase"
                        }}>date</TableCell>
                        <TableCell sx={{
                            fontSize:8,
                            fontWeight:600,
                            textTransform:"uppercase"
                        }}>Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                {sortedNews.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item) => (
                        <TableRow key={item.id}>
                            {/* <TableCell>
                                {item.image && (
                                    <Avatar
                                        variant="rounded"
                                        src={`http://192.168.1.124:3000${item.image}`}
                                        alt={item.title}
                                        sx={{ width: 80, height: 50 }}
                                    />
                                )}
                            </TableCell> */}
                            <TableCell>
                                <Typography 
                                sx={{
                                    fontSize:10,
                                    textTransform:"capitalize",
                                }} variant="body1" fontWeight="bold">
                                    {item.title}
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography
                                sx={{
                                    fontSize:10,
                                    textTransform:"capitalize",
                                }} variant="body2" color="textSecondary">
                                    {item.description.substring(0, 100)}...
                                </Typography>
                            </TableCell>
                              <TableCell>
                                  <Typography
                                  sx={{
                                      fontSize:10,
                                      // textTransform:"capitalize",
                                  }} variant="body2" color="textSecondary">
                                      {item.contact_info}
                                  </Typography>
                              </TableCell>

                            <TableCell>
                              <Typography
                              sx={{
                                  fontSize:10,
                                  textTransform:"capitalize",
                              }}
                                variant="caption" color="textSecondary">
                                  {new Date(item.published_at).toLocaleDateString()}
                              </Typography>
                          </TableCell>
                            <TableCell>
                                <Box  sx={{
                                display:"flex",
                                flexDirection:"row",
                                gap:"10px"
                            }}>
                                    <IconButton onClick={() => handleOpenUpdateDrawer(item)} color="inherit">
                                        <Edit/> 
                                    </IconButton>
                                    <IconButton
                                    color='error'
                                    onClick={()=>handleDelete(item.id)} disabled={deleteMutation.isLoading}
                                    >
                                        <Delete/> 
                                    </IconButton>
                                    <IconButton
                                    onClick={() => handleOpenDetailsDrawer(item)}
                                    >
                                        <Info/> 
                                    </IconButton>
                               </Box>
                            </TableCell>
                               
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
        <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={sortedNews.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
                "& .MuiTablePagination-root": {
                    fontSize: 10, // Adjust overall pagination text size
                    fontWeight: 500,
                    // textTransform: "uppercase",
                },
                "& .MuiTablePagination-toolbar": {
                    fontSize: 10, // Adjust toolbar text size (e.g., "Rows per page")
                    // textTransform:"uppercase"
                },
                "& .MuiTablePagination-selectLabel": {
                    fontSize: 10, // Adjust "Rows per page" text size
                },
                "& .MuiTablePagination-input": {
                    fontSize: 10, // Adjust dropdown text size
                },
                "& .MuiTablePagination-actions button": {
                    fontSize: 10, // Adjust button (next/prev) text size
                },
                "& .MuiSelect-select": {
                    backgroundColor: "#f5f5f5", // Light gray dropdown background
                    borderRadius: "1px",
                    padding: "5px 10px",
                    fontSize: 10, // Adjust dropdown font size
                },
                "& .MuiTablePagination-displayedRows": {
                    fontSize: 10, // Adjust font size of "1–1 of 1"
                    fontWeight: 500,
                    // textTransform: "uppercase",
                },
            }}
            SelectProps={{
                MenuProps: {
                    PaperProps: {
                        sx: {
                            borderRadius: "1px", // Rounded border for dropdown
                            backgroundColor: "#fff", // Background color of dropdown
                            elevation:0,
                            boxShadow:"none",
                            border: "1px solid #ccc", // Optional: Adds a subtle border for separation
                            mt: 1.5, 
                            "& .MuiMenuItem-root": {
                                fontSize: 10, // Dropdown text size
                                fontWeight: 500, // Dropdown text weight
                                "&.Mui-selected": {
                                    backgroundColor: "#001f3f", // Active dropdown item color (red)
                                    color: "white",
                                },
                                "&:hover": {
                                    backgroundColor: "#CCDDEE", // Hover color (lighter red)
                                },
                            },
                        },
                    },
                },
            }}
        />
        </Box>
        )
      )}
       {/* Toast Notifications */}
      <Snackbar
        open={toast.open}
        autoHideDuration={3000}
        onClose={() => setToast({ open: false, message: "", severity: "" })}
      >
        <Alert severity={toast.severity} 
        sx={{
                fontSize: 10, // Adjust font size
                fontWeight:500, // Make text bold
                width: "100%",
                borderRadius: "1px", // Rounded corners
                padding: "10px", // Adjust padding 
                textTransform:"capitalize"
            }}
        >
          {toast.message}
        </Alert>
      </Snackbar>
    </Container>
  )
}

export default ForMore